import { Filmomtale, Genre, ICustomImage } from '@filmweb/sanity-types';
import { CMSCroppedImage } from 'components/images/Image';
import SFacts from 'components/program/SFacts';
import SKinoklubbTicket from 'components/program/SKinoklubbTicket';
import SShowsContainer from 'components/program/SShowsContainer';
import STicketButton from 'components/program/STicketButton';
import isKinoklubb from 'lib/isKinoklubb';
import { IFilm } from 'lib/types/Program';
import { DocumentType_IMAGE, FwPakkeImageDocument, getFilmUrlFromEdi, IMovieArticle } from 'lib/types/sanity';
import Link from 'next/link';

import styles from "./MovieWide.module.css";


//#region [Props]
type MovieWideProps = {
	movie: IFilm;
	fwPakkeMovie?: IMovieArticle;
	filmwebMovie?: Filmomtale;
	isLarge?: boolean;
	allowTitleOverride?: boolean;
};
//#endregion

//#region [Component]
export default function MovieWide({ movie, fwPakkeMovie, filmwebMovie, isLarge = false, allowTitleOverride }: MovieWideProps) {

	const image: FwPakkeImageDocument | ICustomImage | undefined = (fwPakkeMovie?.image as FwPakkeImageDocument) ?? filmwebMovie?.mainImageV2 ?? filmwebMovie?.imagesV2?.[0];

	let title: string = filmwebMovie?.title ?? movie?.title;
	if (allowTitleOverride && fwPakkeMovie?.titleOverride) {
		title = fwPakkeMovie.titleOverride;
	}

	return (<article className={styles.SMovie}>
		{!filmwebMovie && <p>Mangler filmomtale fra Filmweb! ({movie.mainVersionId} - {movie.title})</p>}
		{filmwebMovie && <div className={styles.SImageContainer}>
			{image && <CMSCroppedImage className={styles.SImage} image={image as (ICustomImage | FwPakkeImageDocument)} width={isLarge ? 1440 : 640} heightRatio={isLarge ? (323 / 1200) : (9 / 16)} sizes="(min-width: 641px) 1420px, 640px" isFilmweb={image._type !== DocumentType_IMAGE} altText={`Bilde fra '${filmwebMovie.title}'`} />}
		</div>}
		<div className={styles.STextContainer}>
			<h1 className={styles.SMovieTitle}><Link href={getFilmUrlFromEdi(filmwebMovie?.mainVersionEDI ?? movie.mainVersionId)}>{title}</Link></h1>
			<SFacts>
				{(filmwebMovie?.genres?.length ?? 0) !== 0 && <li className="genre" title="Sjangre">{filmwebMovie?.genres?.map(g => (g as Genre).name).join(" / ")}</li>}
				{filmwebMovie?.runningTime && <li title="Spilletid">{filmwebMovie?.runningTime}</li>}
				{filmwebMovie?.ageRating?.age && <li title="Aldersgrense">{filmwebMovie?.ageRating?.age}</li>}
			</SFacts>
			<SShowsContainer>
				{movie.shows?.map(show => <STicketButton key={`${show.movieMainVersionId}|${show.showStart}`} show={show} showPassed appendShowType showDate />)}
				{filmwebMovie && isKinoklubb(filmwebMovie) && <SKinoklubbTicket />}
			</SShowsContainer>
		</div>
	</article>);
}
//#endregion